import { computed } from '@nuxtjs/composition-api';
import { sharedRef, useVSFContext } from '@vue-storefront/core';
import { XBUY_COOKIE_TOKEN } from '@bee-hole/api';

export const useApiError = (): any => {
  // Loads context used to call API endpoint
  const context = useVSFContext();
  // console.log('useApiError-------------context', context.$cookies);

  // Shared ref holding the response from the API
  const result = sharedRef(null, 'useApiError');

  // Method to call an API endpoint and update `result`, `loading` and `error` properties
  const set = (err: any) => {
    if (err?.code === 61) {
      context.$cookies.remove(XBUY_COOKIE_TOKEN);
    }
    result.value = err;
  };

  return {
    set,
    error: computed(() => result.value),
    ctx: context
  };
};
